module.exports = "/_next/static/images/avatar_5-899800fab9ed3ac07697d62c66de5771.png";